import { Injectable } from '@angular/core';
import * as cartItemActions from '@features/cart-item/actions/cart-item.actions';
import { OrderApiService } from '@features/order/services/order-api/order-api.service';
import * as pointsSummaryActions from '@features/points-summary/store/actions/points-summary.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { CheckoutErrorDialogComponent } from '@rd/shared-legacy/components/checkout-error-dialog/checkout-error-dialog.component';
import { HttpError } from '@rd/types/http-error.type';
import { Order } from '@rd/types/order.type';
import { isNotNull } from '@rd/utils/isNotNull';
import { of } from 'rxjs';
import {
  catchError,
  filter,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import * as actions from '../actions/order-checkout.actions';
import { getCurrentOrder } from '../selectors/current-order.selectors';

@Injectable()
export class CheckoutOrderEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private orderApiService: OrderApiService,
    private dialogService: DialogService,
  ) {}

  checkoutOrderCheckout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.CheckoutOrderActionTypes.CHECKOUT_ORDER),
      withLatestFrom(
        this.store.select(getCurrentOrder).pipe(filter(isNotNull)),
      ),
      switchMap(([payload, { id }]: [{ type: string }, Order]) =>
        this.orderApiService.confirmOrder(id).pipe(
          map((order: Order) => actions.CheckoutOrderSuccess({ order })),
          catchError((error: HttpError) =>
            of(actions.CheckoutOrderFail(error)),
          ),
        ),
      ),
    ),
  );

  checkoutOrderSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.CheckoutOrderActionTypes.CHECKOUT_ORDER_SUCCESS),
      switchMap(
        (action: actions.CheckoutOrderActionTypes.CHECKOUT_ORDER_SUCCESS) => {
          return [
            cartItemActions.LoadCart(),
            new pointsSummaryActions.LoadPointsSummary(),
          ];
        },
      ),
    ),
  );

  checkoutOrderCheckoutFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.CheckoutOrderActionTypes.CHECKOUT_ORDER_FAIL),
        tap((error: HttpError) => {
          this.dialogService.open(CheckoutErrorDialogComponent, {
            data: { error, iconName: 'unexpected-error' },
            id: 'sc-checkout-error-dialog',
            screenMode: 'center-md',
          });
        }),
      ),
    { dispatch: false },
  );
}
